import { render, staticRenderFns } from "./EhrContextBannerEhrOnly.vue?vue&type=template&id=330f8976&scoped=true&lang=pug"
import script from "./EhrContextBannerEhrOnly.vue?vue&type=script&lang=js"
export * from "./EhrContextBannerEhrOnly.vue?vue&type=script&lang=js"
import style0 from "./EhrContextBannerEhrOnly.vue?vue&type=style&index=0&id=330f8976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330f8976",
  null
  
)

export default component.exports